import { AgTechQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import {
  IDemoInventoryAllResponse,
  IDemoInventoryProduct,
  IDemoTypesAllResponse,
  IStatusAllResponse,
} from "../models";
import { URLConfig } from "../network/urlStore";

export const getDemoInventory = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IDemoInventoryAllResponse> => {
  let url = URLConfig.getDemoInvntoryTrialMasterURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoInventoryAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching demo Inventory Data", error);
      }
    );
  });
};
export const getDemoInventoryNextPage = (
  nextPageURI: string
): Observable<IDemoInventoryAllResponse> => {
  const url = URLConfig.getDemoInventoryNextPageTrialMasterURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (demoInventoryResponse) => {
        if (demoInventoryResponse) {
          const demoInventoryResponses =
            demoInventoryResponse as unknown as IDemoInventoryAllResponse;

          subscriber.next(demoInventoryResponses);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Demo Inventory Data", error);
      }
    );
  });
};

export const getContentLengthForDemoInventory = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getDemoInvntoryTrialMasterURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Field Journal Data:", error);
      });
  });
};

export const createDemoInventory = (requestPayload: any): Observable<any> => {
  const url = URLConfig.getDemoInvntoryTrialMasterURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoInventoryAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while adding product in inventory", error);
      }
    );
  });
};

export const getDemoType = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IDemoTypesAllResponse> => {
  let url = URLConfig.getDemoTypeTrialMasterURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoTypesAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Demo Type Data data", error);
      }
    );
  });
};

export const getDemoInventoryById = (
  id?: string,
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: number[];
  }>
): Observable<IDemoInventoryProduct> => {
  let url = URLConfig.getDemoInventoryById(id);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoInventoryProduct;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching demo inventory data", error);
      }
    );
  });
};

export const deleteDemoInventory = (id: string): Observable<any> => {
  const url = URLConfig.getDemoInventoryById(id);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating demoInventory", error);
      }
    );
  });
};

export const updateDemoInventory = (
  requestPayload: any,
  id: string
): Observable<any> => {
  const url = URLConfig.updateDemoInventoryTrialMasterURL(id);
  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoInventoryAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while adding product in inventory", error);
      }
    );
  });
};

export const deleteDemoInventoryProduct = (
  id?: string | undefined,
  demoInventoryProductId?: string | undefined
): Observable<any> => {
  const url = URLConfig.deleteDemoInventoryProductTrialMasterURL(id,demoInventoryProductId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating demoInventoryProduct", error);
      }
    );
  });
};

export const patchDemoInventoryProduct = (
  id?: string | undefined,
  // trialId: number,
  requestPayload?: any
): Observable<any> => {
  const url = URLConfig.patchDemoInventoryProductTrialMasterURL(id);
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the demo Inventory Products", error);
      }
    );
  });
};

export const getSignData = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<Array<{ value: string; label: string }>> => {
  let url = URLConfig.getSignDataTrialMasterURL();

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (repInfoResponse: unknown) => {
        if (repInfoResponse) {
          const res = repInfoResponse as unknown as IStatusAllResponse;

          const formattedData = res.values.map((item: string) => ({
            value: item,
            label: item,
          }));

          subscriber.next(formattedData);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Sign data", error);
      }
    );
  });
};

export const lineOfBusinessData = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<Array<{ value: string; label: string }>> => {
  let url = URLConfig.getLineOfBusinessDataTrialMasterURL();

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (repInfoResponse: unknown) => {
        if (repInfoResponse) {
          const res = repInfoResponse as unknown as IStatusAllResponse;

          const formattedData = res.values.map((item: string) => ({
            value: item,
            label: item,
          }));

          subscriber.next(formattedData);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Line of Business data", error);
      }
    );
  });
};
